import {html} from "../libs/lit.dist.js";
import {WebElement} from "./abstract-element.js";
import {showErrorPopup} from "../util/errors.js";
import {copyToClipboard} from "../util/browser.js";
import {successAlert} from "../alerts.js";

/**
 * Przycisk "Kopiuj do schowka"
 * Atrybuty:
 *  {string} content - Treść do skopiowania
 *  {string} title   - Tekst po najechaniu kursorem
 *  {string} message - Komunikat po skopiowaniu treści do schowka
 *  {string} icon    - Ikona wyświetlana w przycisku
 *
 * Przykład użycia:
 * <pk-copy-button content="Treść do skopiowania"></pk-copy-button>
 */
export class PkCopyButton extends WebElement {

    static get properties() {
        return {
            content: {type: String},
            message: {type: String},
            icon: {type: String},
            label: {type: String},
            rel: {type: String},
        };
    }

    constructor() {
        super();
        this.icon = 'fal fa-copy';
        this.message = 'Skopiowano tekst';
        this.label = '';

        // Ikona na front
        if (POLKURIER && POLKURIER.FA_ICON_TYPE === 'fa') {
            this.icon = 'bi bi-files';
        }
    }

    #getContent() {
        if (typeof this.content === 'function') {
            return this.content();
        }
        if (!this.content && this.rel) {
            return document.querySelector(this.rel)?.innerText
        }
        return this.content;
    }

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cursor-pointer');
        this.title = this.title || 'Skopiuj do schowka';
        this.addEventListener('click', async () => {
            try {
                await copyToClipboard(this.#getContent());
                if (this.message) {
                    successAlert(this.message, {useToasts: true});
                }
            } catch (e) {
                showErrorPopup(e, {useToasts: true});
            }
        });
    }

    render() {
        return html`<i class="${this.icon}"></i>${this.label}`;
    }
}

window.customElements.define('pk-copy-button', PkCopyButton);
